import { z } from 'zod';

/**
 * Current privacy notice version (apps/tma/privacy.html shows the same
 * string). Bump it whenever the text changes — every user re-accepts on the next
 * open. Deploy the API no later than the Mini App when bumping it.
 */
export const PD_POLICY_VERSION = '2026-10-13';

/** POST /profile/consent */
export const consentAcceptSchema = z
  .object({
    policyVersion: z.string().min(1).max(32),
  })
  .strict();

export type ConsentAcceptInput = z.infer<typeof consentAcceptSchema>;
